import React, { useEffect } from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import SimpleModal from "../../../components/SimpleModal/SimpleModal";
import { AvailabilitiesListService } from "../../../services/AvailabilitiesListService";
import { AvailabilityListForm } from "./AvailabilityListForm";
import { toast } from "react-toastify";

export default function MakeAvailableModal({
  isOpen,
  onClose,
  availabilityList,
  setAvailabilityList,
  docStatus,
  docStatusLabel,
  validate,
  processResponse,
  error,
  contractTypes
}) {
  let { t } = useTranslation();

  function createavailabilitiesListCandidate() {
    if (validate()) {
      AvailabilitiesListService.createAvailabiltiesList(availabilityList).then(
        (data) => {
          processResponse(data);
          toast.success(t("Availability created successfully"));
          onClose();
        }
      );
    }
  }

  return (
    <SimpleModal
      isOpen={isOpen}
      onClose={onClose}
      title={`${t("The candidate will be available,do you want to proceed?")}`}
      submitButtonAction={createavailabilitiesListCandidate}
      cancelButtonAction={onClose}
      size={"md"}
    >
      <AvailabilityListForm
        availabilityList={availabilityList}
        setAvailabilityList={setAvailabilityList}
        t={t}
        docStatus={docStatus}
        docStatusLabel={docStatusLabel}
        error={error}
        validate={validate}
        contractTypes={contractTypes}
      />
    </SimpleModal>
  );
}
